import { render, staticRenderFns } from "./editVendorComponent.vue?vue&type=template&id=ad843340&"
import script from "./editVendorComponent.vue?vue&type=script&lang=js&"
export * from "./editVendorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports